import { reduxForm, Field, FieldArray, change, submit } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { AutoComplete } from '../../../../itrust_common/components/others';
import { InputWithIcon, Input } from '../../../../itrust_common/components/form';
import { onlyLetters } from '../../../../itrust_common/components/form/FormValidations';
import DiscountField from './DiscountField';
import ImportWrapper from './import/ImportWrapper';
import { orderCloseModal } from '../../../../redux/actions/order/orderActions';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';
import { useEffect } from 'react';

function ProcedureForm(props) {
  const { handleSubmit, order, onSubmit, currency } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(orderCloseModal(false))
    }
  }, [])

  return (
    <form onSubmit={handleSubmit}>
      <div className="col-12 mb-7">
        <div className={`d-flex justify-content-between align-items-center ${order.status !== "finalized" && 'mt-6'}`}>
          <h5>Procedures</h5>
          <ImportWrapper order={order} importName="procedure" />
        </div>
      </div>
      <div className="card border-0 shadow-sm px-5">
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <label>Add Procedure</label>
              <AutoComplete
                textField="name"
                klass="ProcedurePricing"
                wrapperClasses="col-4 px-0"
                valueField="settings_procedure_id"
                otherFilters={{ filter: { for_store: order.store_id } }}
                placeholder="Type in to search by procedure name or code"
                onSelect={(settings_procedure_id) => {
                  onSubmit({ id: order.id, procedures_attributes: [{ settings_procedure_id: settings_procedure_id }] })
                }}
              />
            </div>
            <div className="col-12 mt-7">
              <div className="overview-table px-2">
                <table className="table table-hover shadow-none">
                  <thead className="text-dark border-bottom bg-light border-white border-bottom-2">
                    <tr>
                      <th scope="col">No.</th>
                      <th scope="col">Description</th>
                      <th scope="col">Code</th>
                      <th scope="col">Impression pointer</th>
                      <th scope="col">Unit Price (in {currency.symbol})</th>
                      <th scope="col">Copay</th>
                      {order.orders_insurances_attributes.length ?
                        <>
                          <th scope="col">Coinsurance</th>
                          <th scope="col">Deductible</th>
                          <th scope="col">Allowance</th>
                        </> :
                        <th scope="col">Discount</th>
                      }
                      <th scope="col">Subtotal</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <FieldArray
                    name="procedures_attributes"
                    props={{ pprops: props, dispatch }}
                    component={RenderProcedures}
                  />
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

function RenderProcedures(props) {
  const { fields, pprops, pprops: { currency, order }, dispatch } = props;
  return (
    <tbody>
      {fields.map((member, index, members) => (
        <tr key={`procedure-${index}`} className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td>{index + 1}</td>
          <td>{members.get(index).description}</td>
          <td>{members.get(index).exam_code}</td>
          <td>
            <Field name={`${member}[pointer]`} component={Input} title="" className="form-control" wrapperClasses="d-flex w-75" validate={[onlyLetters]} />
          </td>
          <td>
            <Field name={`${member}[unit_price]`} type="number" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses="d-flex w-75" onBlur={() => dispatch(submit('orderProcedureForm'))} />
          </td>
          <td>
            <Field name={`${member}[copay]`} type="number" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses="d-flex w-75" onBlur={() => dispatch(submit('orderProcedureForm'))} />
          </td>
          {order.orders_insurances_attributes.length > 0 ?
            <>
              <td>
                <Field name={`${member}[coinsurance]`} type="number" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses="d-flex w-75" onBlur={() => dispatch(submit('orderProcedureForm'))} />
              </td>
              <td>
                <Field name={`${member}[deductible]`} type="number" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses="d-flex w-75" onBlur={() => dispatch(submit('orderProcedureForm'))} />
              </td>
              <td>
                <Field name={`${member}[allowance]`} disabled={members.get(index).allowance == null} type="text" component={InputWithIcon} title={currency.symbol} className="form-control" wrapperClasses="d-flex w-75" onBlur={() => dispatch(submit('orderProcedureForm'))} />
              </td>
            </>
            :
            <td>
              <div className="d-flex w-75">
                <DiscountField
                  cashName={`${member}[cash_discount]`}
                  percentageName={`${member}[percentage_discount]`}
                  discountTypeName={`${member}[discount_type]`}
                  defaultType={members.get(index).discount_type}
                  onBlur={() => dispatch(submit('orderProcedureForm'))}
                />
              </div>
            </td>
          }
          <td><CurrencyTypeView amount={members.get(index).subtotal} /></td>
          <td>
            <a className="badge badge-pill badge-primary" onClick={() => { dispatch(change('orderProcedureForm', `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 500) }}>
              <i className="la la-trash"></i>
            </a>
          </td>
        </tr>
      ))}
      {(fields.length > 0 && order.orders_insurances_attributes.length === 0) && <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
        <td></td>
        <td colSpan="5" className="text-right">
          <h6>Overall Discount</h6>
        </td>
        <td>
          <div className="d-flex w-75">
            <DiscountField
              cashName="cash_procedures_discount"
              percentageName="percentage_procedures_discount"
              discountTypeName="procedures_discount_type"
              defaultType={order.procedures_discount_type}
              onBlur={() => dispatch(submit('orderProcedureForm'))}
            />
          </div>
        </td>
        <td></td>
        <td></td>
      </tr>}
    </tbody>
  )
}

ProcedureForm = reduxForm({
  form: 'orderProcedureForm',
  enableReinitialize: true,
  onChange: (values, dispatch, props) => {
    if (props.dirty) {
      dispatch(orderCloseModal(true))
    }
  }
})(ProcedureForm)

const mapStateToProps = (state) => {
  const { order } = state.order
  const { organisation: { organisation } } = state
  return {
    currency: organisation.preferences.currency,
    order: order,
    initialValues: {
      id: order.id,
      percentage_procedures_discount: order.percentage_procedures_discount,
      cash_procedures_discount: order.cash_procedures_discount,
      procedures_discount_type: order.procedures_discount_type,
      procedures_attributes: order.procedures_attributes
    }
  }
}

export default connect(mapStateToProps)(ProcedureForm);